export default __webpack_public_path__ + "static/media/quienesSomos3.42fba6d3.jpg";